(function() {
    var script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/framer-motion@10.16.2/dist/framer-motion.umd.min.js";
    script.onload = function() {
        console.log("✅ Framer Motion cargado");
        window.motion = window.framerMotion; // Hace que sea accesible globalmente
    };
    document.head.appendChild(script);
})();
